exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.person-of-trust__selected[data-v-d7cf6b14] {\n  background-color: rgba(0, 0, 0, .08);\n  border: 2px solid #ccc;\n}\n.cursorBcard[data-v-d7cf6b14] {\n  cursor: pointer;\n}\n.btn-estate-administration[data-v-d7cf6b14]:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d7cf6b14","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contracts/ContractEstateDetails.vue
// module id = tsE0
// module chunks = 1